const DEBUG: boolean = false

export const APIROOT = DEBUG ? '.' : 'https://raw.githubusercontent.com/mattbierner/post-mortem/master'  


// WEBPACK FOOTER //
// ./src/config.ts